<template>

  <div>

    <div v-if="item && item.fields && item.fields.length" class="mb-4">
      <div v-for="(element, index) in item.fields" :key="index">
        <field-view :field="element.field" :is-encrypted="element.isEncrypted" :value="element.values" v-if="element.values" />
      </div>
    </div>

    <el-form ref="form" :model="item" :rules="validation" label-width="80px">
      <el-form-item label="Name" prop="reservation.fullname">
        <el-input v-model="item.reservation.fullname" id="fullname" />
      </el-form-item>

      <el-form-item label="Party size" prop="reservation.partySize">
        <el-radio-group v-model="item.reservation.partySize" @change="updateEndtime()">
          <el-radio-button label="1"></el-radio-button>
          <el-radio-button label="2"></el-radio-button>
          <el-radio-button label="3"></el-radio-button>
          <el-radio-button label="4"></el-radio-button>
          <el-radio-button label="5"></el-radio-button>
          <el-radio-button label="6"></el-radio-button>
          <el-radio-button label="7"></el-radio-button>
          <el-radio-button label="8"></el-radio-button>
          <el-radio-button label="9"></el-radio-button>
          <el-radio-button label="10"></el-radio-button>
          <div>
          <el-radio-button label="11"></el-radio-button>
          <el-radio-button label="12"></el-radio-button>
          <el-radio-button label="14"></el-radio-button>
          <el-radio-button label="16"></el-radio-button>
          <el-radio-button label="18"></el-radio-button>
          <el-radio-button label="20"></el-radio-button>
          <el-radio-button label="25"></el-radio-button>
          <el-radio-button label="30"></el-radio-button>
          <el-radio-button label="35"></el-radio-button>
          <el-radio-button label="40"></el-radio-button>
          </div>
        </el-radio-group>

      </el-form-item>

      <el-form-item label="Date" prop="reservation.reservationDate">
        <el-date-picker
          v-model="reservationDate" format="dd.MM.yyyy"
          type="date"
          placeholder="Pick a day">
        </el-date-picker>
        from
        <el-time-select v-model="reservationTime" :picker-options="{ start: '00:00', step: '00:15', end: '23:59' }" placeholder="Select time"></el-time-select> to
        <el-time-select v-model="item.reservation.leavingTime" :picker-options="{ start: '00:00', step: '00:15', end: '23:59' }" placeholder="Select time"></el-time-select>
      </el-form-item>

      <el-form-item label="Phone" prop="reservation.phone">
        <el-input v-model="item.reservation.phone" id="phone" />
      </el-form-item>

      <el-form-item label="Comment" prop="reservation.comment">
        <el-input type="textarea" v-model="item.reservation.comment" />
      </el-form-item>

      <el-form-item label="Room" prop="reservation.reservationRoom">
        <el-select v-model="item.reservation.reservationRoom" placeholder="Select room">
          <el-option
            v-for="room in rooms"
            :key="room._id"
            :label="room.title"
            :value="room._id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Tables" prop="reservation.reservationTables">
        <div>
          <div v-for="(table, i) in item.reservation.reservationTables" :key="i" class="mb-2">
          <el-select v-model="item.reservation.reservationTables[i]" placeholder="Select table">
            <el-option
              v-for="table in tables"
              :key="table.title"
              :label="table.title + ' (' + table.size + (table.size == '1' ? ' person)' : ' people)')"
              :value="table.title">
            </el-option>
          </el-select>
            <a href="" @click.prevent="removeTable(i)" ><span class="fa fa-trash"></span></a>
          </div>

          <div>
          <a href="" @click.prevent="addTable">Add table</a>
          </div>
        </div>
      </el-form-item>

      <el-form-item size="large">
        <el-button type="primary" :loading="loading" @click="onSubmit">
          <span v-if="item._id">Save</span>
          <span v-else>Create</span>
        </el-button>
        <el-button @click="onCancel">
          Close
        </el-button>

        <el-button type="success" :loading="loading" @click="onArrived" v-if="!item.reservation.isArrived">
          Guests arrived
        </el-button>
        <el-button type="success" outline :loading="loading" @click="onNotArrived" v-else>
          Guests not arrived
        </el-button>

        <el-button type="danger" :loading="loading" @click="onDelete" class="pull-right">
          Cancel order
        </el-button>
      </el-form-item>
    </el-form>


  </div>
</template>
<style scoped>
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 193px;
  }
</style>
<script>
import moment from 'moment';
import fieldView from '../components/fieldView';

  export default {
    props: ['item', 'rooms'],
    components: {
      fieldView
    },
    computed: {
      tables() {
        if (!this.item || !this.item.reservation || !this.item.reservation.reservationRoom) {
          return [];
        }
        let room = this.rooms.find(r => this.item.reservation.reservationRoom == r._id);
        if (!room) {
          return [];
        }
        let settings;
        try {
          settings = JSON.parse(room.settings);
        } catch (err) {
          return [];
        }
        return settings.objects.sort(natural_compare);

        function pad(n) { return ("00000000" + n).substr(-8); }
        function natural_expand(a) {
          return a.title.replace(/\d+/g, pad);
        }
        function natural_compare(a, b) {
          return natural_expand(a).localeCompare(natural_expand(b));
        }
      },
      reservationTime: {
        get() {
          return this.reservTime || moment(this.item.reservation.reservationDate).format('HH:mm');
        },
        set(v) {
          this.reservTime = v;
        }
      },
      reservationDate: {
        get() {
          return this.item.reservation.reservationDate;
        },
        set(v) {
          this.item.reservation.reservationDate = moment(
            `${moment(v).format('DD-MM-YYYY')} ${moment(this.item.reservation.reservationDate).format('HH:mm')}`,
            'DD-MM-YYYY HH:mm'
          ).toDate();
        }
      }
    },
    methods: {
      updateEndtime() {
        this.item.reservation.leavingTime = moment(this.item.reservation.reservationDate).add(this.getPartyTimespent(+this.item.reservation.partySize), 'h').format('HH:mm');
      },

      getPartyTimespent(size) {
        switch (size) {
          case 1:
          case 2:
            return 1.75;
          case 3:
          case 4:
            return 2.25;
          default:
            return 3.25;
        }
      },
      async onSubmit() {
        if (!await this.isValid()) {
          return this.$message.error('Fill field correctly!');
        }
        this.loading = true;
        try {
          if (this.reservTime) {
            this.item.reservation.reservationDate = moment(
              `${moment(this.item.reservation.reservationDate).format('DD-MM-YYYY')} ${this.reservTime}`,
              'DD-MM-YYYY HH:mm'
            ).toDate();
          }

          await this.$store.dispatch('createNewOrder', this.item);
          this.$message.success('Saved!');
          this.$emit('create');
        } catch (err) {
          this.$message.error('Error: ' + err.message);
        }
        this.loading = false;
      },
      onCancel() {
        this.$emit('cancel');
      },
      addTable() {
        this.item.reservation.reservationTables.push('');
      },
      removeTable(n) {
        this.item.reservation.reservationTables.splice(n, 1);
      },
      async onArrived() {
        this.loading = true;
        try {
          this.item.reservation.isArrived = true;
          await this.$axios.put(`/v1/reservations/${this.item._id}`, this.item);
          this.$message.success('Saved!');
        } catch (err) {
        }
        this.loading = false;
      },
      async onNotArrived() {
        this.loading = true;
        try {
          this.item.reservation.isArrived = false;
          await this.$axios.put(`/v1/reservations/${this.item._id}`, this.item);
          this.$message.success('Saved!');
        } catch (err) {
        }
        this.loading = false;
      },
      async onDelete() {
        this.loading = true;
        try {
          await this.$confirm('This will cancel the order and notify client by email. Continue?', 'Warning', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning'
          });
          this.loading = true;
          await this.$axios.delete(`/v1/reservations/${this.item._id}`);
          this.$message.success('Order canceled!');

          this.$emit('deleted');
        } catch (err) {
        }
        this.loading = false;
      },
      async isValid() {
        return new Promise((success) => {
          return this.$refs['form'].validate(valid => success(valid));
        });
      }
    },
    data() {
      return {
        reservTime: null,
        loading: false,
        validation: {
          'reservation.fullname': [{required: true, trigger: "blur"}],
          'reservation.reservationDate': [{required: true, trigger: "blur"}],
          'reservation.reservationTime': [{required: true, trigger: "blur"}],
          'reservation.partySize': [{required: true, trigger: "blur"}]
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// CreateOrderDialog.vue?2da09954